import * as mixinUtil from "./mixinUtil";

export default class BaseClass {

  constructor(props) {
    mixinUtil.mixin(this,props);
  }

  clearHandles() {
    let handles = this._handles;
    if (!Array.isArray(handles)) return;
    handles.forEach((h) => {
      try {
        if (h && typeof h.remove === "function") {
          // Dojo handle
          h.remove();
          //console.log("BaseClass::destroy - handle removed");
        }
      } catch(ex) {
        console.warn("Error BaseClass::destroy - error removing handle:",h);
        console.error(ex);
      }
    });
    this.handles = [];
  }

  destroy() {
    this.clearHandles();
  }

  own(handles) {
    try {
      if (!handles) return;
      if (!Array.isArray(handles)) handles = [handles];
      if (handles.length === 0) return;
      if (this._handles) {
        this._handles = this._handles.concat(handles);
      } else {
        this._handles = handles.slice();
      }
    } catch(ex) {
      console.warn("Error tracking handles:",this);
      console.error(ex);
    }
  }

}
